const getProfileAsAttributes = `
    query
    {
        profileAsAttributes {
            code
            value
        }
    }
`;

export default getProfileAsAttributes;
